export default "__VITE_ASSET__wJYFDmiZ__"